export const TABS = [
  { id: 'self',  label: 'Я отримувач' },
  { id: 'other', label: 'Інший отримувач' },
  { id: 'legal', label: 'Юридична особа' },
];

/**
 * Field schema per receiver tab.
 *
 * A field with `requiredForCarriers: ['ukrposhta']` is optional in general but
 * becomes required when that delivery method is selected. The contact section
 * uses this to show the asterisk dynamically; the form validator does the
 * same check at submit time.
 */
export const TAB_FIELDS = {
  self: [
    { name: 'lastName',  label: 'Прізвище',          required: true,  type: 'text' },
    { name: 'firstName', label: "Ім'я",              required: true,  type: 'text' },
    { name: 'phone',     label: 'Телефон',           required: true,  type: 'phone' },
    { name: 'email',     label: 'Електронна пошта',  required: false, type: 'email' },
  ],
  other: [
    { name: 'lastName',     label: 'Ваше прізвище',           required: true,  type: 'text' },
    { name: 'firstName',    label: "Ваше ім'я",               required: true,  type: 'text' },
    { name: 'phone',        label: 'Ваш телефон',             required: true,  type: 'phone' },
    { name: 'email',        label: 'Ваша електронна пошта',   required: false, type: 'email' },
    { name: 'rcvLastName',  label: 'Прізвище отримувача',     required: true,  type: 'text' },
    { name: 'rcvFirstName', label: "Ім'я отримувача",         required: true,  type: 'text' },
    { name: 'rcvPhone',     label: 'Телефон отримувача',      required: true,  type: 'phone' },
  ],
  legal: [
    { name: 'company',   label: 'Назва компанії',             required: true,  type: 'text', full: true },
    { name: 'edrpou',    label: 'ЄДРПОУ / ІПН',                required: true,  type: 'text' },
    { name: 'vat',       label: 'ІПН платника ПДВ',            required: false, type: 'text' },
    { name: 'lastName',  label: 'Прізвище контактної особи',  required: true,  type: 'text' },
    { name: 'firstName', label: "Ім'я контактної особи",      required: true,  type: 'text' },
    { name: 'phone',     label: 'Телефон',                     required: true,  type: 'phone' },
    { name: 'email',     label: 'Електронна пошта',            required: true,  type: 'email' },
  ],
};

/**
 * Computes the *effective* required flag for a field given the current
 * delivery method. Used both by the renderer (for the placeholder asterisk)
 * and the validator.
 */
export function isFieldRequired(field, deliveryMethodId) {
  if (field.required) return true;
  if (Array.isArray(field.requiredForCarriers) && field.requiredForCarriers.includes(deliveryMethodId)) return true;
  return false;
}
